/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DateRangeService {
   appState: any
   currentSelection: any
   data: any
   datePresetLabels: any
   defaultPresets: any
   events: any
   facetDatepicker: any
   range: any
   results: any
   selection: any
   today: any
   utils: any
   searchScopeService: SearchScopeService
   fire: any
   on: any
   constructor(appState: any, results: any, events: any, utils: any, searchScopeService: SearchScopeService, hooksService: HooksService) {
      this.onResults = this.onResults.bind(this)
      this.onAppState = this.onAppState.bind(this)
      this.update = this.update.bind(this)
      this.reflect = this.reflect.bind(this)
      this.determinePresetSelectedYears = this.determinePresetSelectedYears.bind(this)
      this.setSelection = this.setSelection.bind(this)
      this.retrieveSince = this.retrieveSince.bind(this)
      this.applySelection = this.applySelection.bind(this)
      this.clearSelection = this.clearSelection.bind(this)
      this.isValidSelection = this.isValidSelection.bind(this)
      this.hasSelectionChanged = this.hasSelectionChanged.bind(this)
      this.toggleBtnDatepicker = this.toggleBtnDatepicker.bind(this)
      this.appState = appState
      this.results = results
      this.events = events
      this.utils = utils
      this.data = {}
      this.today = new Date()
      this.range = {
         start: null,
         end:   null
      }
      this.selection = {
         start: null,
         end:   new Date(this.today.setHours(0, 0, 0, 0)),
         selectedYears: null
      }
      this.currentSelection = angular.copy(this.selection)
      this.defaultPresets = {"1Y": 1, "3Y": 3, "5Y": 5, "10Y":10}
      this.datePresetLabels = {'1Y': '_1_YEAR', '3Y': '_3_YEARS', '5Y': '_5_YEARS', '10Y': '_10_YEARS'}

      // register dataService hooks
      this.results.on("new", this.onResults)
      this.appState.on("apply", this.onAppState)
      this.facetDatepicker = {collapsed : true}
      this.searchScopeService = searchScopeService

      hooksService.setHooks(this, 'DateRangeService', ['setAdvancedSelection'])
   }

   onResults() {
      return this.update(this.results.data.search)
   }

   onAppState() {
      return this.reflectEitherParams()
   }

   // callback for dataService hook
   update(data: any) {
      // if we have a selection, honor it
      this.range.start = !!this.selection.start && this.selection.start.getFullYear()
      return this.range.end   = !!this.selection.end   && this.selection.end.getFullYear()
   }

   searchScopeDateIsApplied(){
      return !!(this.appState.searchScopeParams?.rf ?? []).find((f: any) => f.indexOf('PublicationDate') === 0)
   }

   reflectEitherParams(){
      if (this.searchScopeDateIsApplied()){
         return this.reflect(this.appState.searchScopeParams)   
      } 
      return this.reflect(this.appState.params)
   }

   reflect(params: any) {
      let from = null
      let to   = null
      const rangeFacet = _(params.rf).find((f: any) => f.indexOf('PublicationDate') === 0)
      const date = new Date()

      if (rangeFacet) {
         const range = rangeFacet.split(",")[1].replace(/\-/g, '/');
         [from, to] = range.split(":").map(function(d: any) { if (d !== "*") { return new Date(d) } else { return null } })
      }
      const selectedYears = this.determinePresetSelectedYears(from, to)
      if (selectedYears){
         to = null
      }
      this.setSelection({
         start: from,
         end: to ,
         selectedYears
      })
      this.currentSelection = angular.copy(this.selection)
      this.facetDatepicker.collapsed = ((from === null) && ((to === null) || (to.toString() === new Date(date.setHours(0, 0, 0, 0)).toString()))) || selectedYears
      const isRangeSelected = (from !== null) || (to !== null)
      return isRangeSelected
   }

   determinePresetSelectedYears(from: any, to: any) {
      if (from === null) {
         return null
      }

      let isToToday = false
      const today = new Date()
      const day = today.getDate()
      const month = today.getMonth()
      const year = today.getFullYear()

      if (to === null) {
         isToToday = true
      } else if ((to.getDate() === day) && (to.getMonth() === month) && (to.getFullYear() === year)) {
         isToToday = true
      }

      if (isToToday && (from.getDate() === day) && (from.getMonth() === month)) {
         return year - from.getFullYear()
      } else {
         return null
      }
   }

   // update selection, start and/or end can be null for 'open ended'
   setSelection(attrs: any, advanced = false) {
      if(advanced) {
         this.fire('setAdvancedSelection', attrs)
      } else {
         this.selection.start = attrs.start
         this.selection.end   = attrs.end
         this.selection.selectedYears = attrs.selectedYears
      }
   }

   retrieveSince(years: any) {
      const date = new Date()
      // Generate a compounded object of a date range
      return {
         start: new Date(date.getFullYear() - years, date.getMonth(), date.getDate()),
         end: null,
         selectedYears: years
      }
   }

   applySelection() {
      if (!this.hasSelectionChanged()) { return }
      //every change in date range should reset the page number to 1
      this.appState.params.pn = 1
      const setState = () => {
         this.currentSelection = angular.copy(this.selection)
         if ((this.selection.start != null) || (this.selection.end != null)) {
            const from = this.utils.dateToFilterDate(this.selection.start)
            const to   = this.utils.dateToFilterDate(this.selection.end)
            this.appState.params.rf = _(this.appState.params.rf).reject((f: any) => f.indexOf('PublicationDate') === 0)
            this.appState.params.rf.push(`PublicationDate,${from}:${to}`)
            this.events.gaPush('refinements', 'add', this.appState.params.rf)
         } else {
            this.appState.params.rf = []
            this.events.gaPush('refinements', 'clear', 'PublicationDate')
         }
      } 
      this.appState.applyStateWithSnapShot(setState);
   }

   checkForSearchScope( advanced = '', advScopeParams: any, callBack?: (goBackToSearchScope: boolean, callbackDateParams: any) => void , callbackDateParams?: any){
      const params = advScopeParams || this.appState.searchScopeParams
      if(params.rf && params.rf.some((rf: any) => (rf.indexOf('PublicationDate') > -1))){
         this.searchScopeService.clearScopeAsSideEffect(advanced, callBack, callbackDateParams)
         return true
      }
      return false
   }

   clearSelection(applyState = true){
      this.setSelection({start: null, end: null, selectedYears: null})
      if (applyState) {
         return this.applySelection()
      }
   }

   isValidSelection() {
      return (this.selection.start == null) || (this.selection.end == null) || (this.selection.start <= this.selection.end)
   }

   hasSelectionChanged() {
      // check start
      return ((this.selection.start != null) && (this.currentSelection.start == null)) ||
    ((this.selection.start == null) && (this.currentSelection.start != null)) ||
    ((this.selection.start != null) && (this.currentSelection.start != null) && (this.selection.start.getTime() !== this.currentSelection.start.getTime())) ||
    // check end
    ((this.selection.end != null) && (this.currentSelection.end == null)) ||
    ((this.selection.end == null) && (this.currentSelection.end != null)) ||
    ((this.selection.end != null) && (this.currentSelection.end != null) && (this.selection.end.getTime() !== this.currentSelection.end.getTime()))
   }

   //### internal (private) methods

   normalize(data: any) {
      const values = {}
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      data.forEach((value: any) => values[value.year] = value.count)
      return values
   }

   toggleBtnDatepicker() {
      return this.facetDatepicker.collapsed = !this.facetDatepicker.collapsed
   }
}


DateRangeService.$inject = ['appStateService', 'dataService', 'eventService', 'utilitiesService', 'searchScopeService', 'hooksService']
angular.module('summonApp.services')
   .service('dateRangeService', DateRangeService)
